<wl-modal (closeModal)="closeModal()" [modalTitle]="product.content.longTitle">
  <ng-template wlModalBody>
    <div class="d-flex flex-column gap-2">
      <p class="mb-0">
        <strong>+ {{ product.price | euroCurrency: '1.0-2' }}</strong>
        {{ labels.perMonthLong }}
      </p>
      <p class="mb-0" *wlGenericRichText="product?.content?.longSubtitle"></p>
      <wl-generic-usps [usps]="usps" />
      <button
        class="btn btn-primary w-100"
        (click)="selectProduct()"
        [wlAutomationId]="'accept-cross-sell-product'"
      >
        {{ labels.addProduct }}
      </button>
      <button
        class="p-0 btn btn-link w-100 text-primary"
        (click)="rejectProduct()"
        [wlAutomationId]="'reject-cross-sell-product'"
      >
        {{ labels.rejectProduct }}
      </button>
    </div>
  </ng-template>
</wl-modal>
